<div class="menu-group-title">{{ title }}</div>
<ng-content></ng-content>
